import React from 'react';
import {Class, JSTypeOperator, ObjectTypes} from "../../../../GenericCoreGraph/ClassFramework/Class"
import TObject from "../../../../TagComponents/TObject"
import Typography from "@material-ui/core/Typography";
import TBaseDialogModal from "../../../Utilities/TBaseDialogModal";
import {Dialog} from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import Actions from "../../../../GenericWebController/ActionGraph/Actions";
import {CommandIDs} from "../../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs";
import Paper from "@material-ui/core/Paper";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import GenericWebGraph from "../../../../GenericWebController/GenericWebGraph";


var TSSSModal = Class(TBaseDialogModal,
  {
    ObjectType: ObjectTypes.Get("TSSSModal")
    ,
    constructor: function (_Props) {
      TSSSModal.BaseObject.constructor.call(this, _Props);
      this.state =
        {
          ...this.state,
          open: false,
          contractCode: null,
          title: null,
          language: null
        };
        window.App.SSSModal = this;
    }
    ,
    AsycLoad: function () {
      var __This = this;
      __This.HandleGetTemplateDetail();
    },
    Destroy: function () {
      TSSSModal.BaseObject.Destroy.call(this);
    }
    ,

    HandleGetTemplateDetail: function () {
      var __This = this;
      Actions.GetTemplateDetailByCode(
        __This.state.contractCode,
        __This.state.language,
        function (_Message) {
          CommandIDs.ResultItemCommand.RunIfHas(_Message, function (_Data) {
            __This.setState({
              templateDetail: _Data.Item.TemplateDetail,
            });
          });
        }
      );
    },
    HandleClickOpen: function (_ParamObject, _CallbackOnClose)
    {
      TSSSModal.BaseObject.HandleClickOpen.call(this, _ParamObject, _CallbackOnClose);
      this.CallbackOnClose = _CallbackOnClose;
      this.setState({
        open: true,
        contractCode: _ParamObject.ContractCode,
        title: _ParamObject.Title,
        language: _ParamObject.Language
      },()=>{
        this.HandleGetTemplateDetail()
      });
    }
    ,
    HandleClose: function () {
      this.setState({
        open: false
      });

      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    }
    ,
    render: function () {
      var __This = this;
      var __Params = TSSSModal.BaseObject.render.call(this);
      if (!__Params.NeedRender) {
        return  null;
      }
      return (this.HandleWrapModal(
        <div>
          <DialogTitle>
            <Grid container>
              <Grid item xs={11}>
                <Typography variant={"h5"}>
                  {__This.state.title}
                </Typography>
              </Grid>
              <Grid item xs={11}/>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
              <div
                dangerouslySetInnerHTML={{
                  __html: __This.state.templateDetail,
                }}
              />
          </DialogContent>
        </div>)
      );
    }
  }, {});

export default TSSSModal

